const getKey = () => `gettingPassportInitiated`;

export const getGettingPassportInitiate = () => {
  try {
    return JSON.parse(sessionStorage.getItem(getKey()));
  } catch (e) {}
};

export const setGettingPassportInitiate = () => {
  sessionStorage.setItem(getKey(), JSON.stringify(true));
};

export const removeGettingPassportInitiate = () => {
  sessionStorage.removeItem(getKey());
};
